;(function () {
    // console.log('Animations.js loaded')

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initViewAnimations)
    } else {
        initViewAnimations()
    }

    function initViewAnimations() {
        console.log('Initializing view animations...')

        // Components loading animations
        let elementsToObserve = document.querySelectorAll('.view-animation')
        // console.log(
        //     `Found ${elementsToObserve.length} elements with view-animation class`
        // )

        // Log the first few elements for debugging
        elementsToObserve.forEach((el, index) => {
            if (index < 3) {
                // console.log(
                //     `Element ${index}:`,
                //     el.tagName,
                //     el.className,
                //     el.src || el.textContent?.substring(0, 50)
                // )
            }
        })

        // Check if IntersectionObserver is supported
        if (!window.IntersectionObserver) {
            // console.warn(
            //     'IntersectionObserver not supported, adding animated class to all elements'
            // )
            elementsToObserve.forEach((el) => el.classList.add('animated'))
            return
        }

        // intersection observer not support on ie11
        let isIE11 = !!window.MSInputMethodContext && !!document.documentMode

        if (isIE11) {
            // console.log('IE11 detected, adding animated class to all elements')
            elementsToObserve.forEach((el) => el.classList.add('animated'))
            return
        }

        // Track elements that are currently animating to prevent multiple timeouts
        const animatingElements = new Map()

        // Function to get delay time based on delay class
        function getDelayTime(element) {
            if (element.classList.contains('delay-1')) return 200
            if (element.classList.contains('delay-2')) return 400
            if (element.classList.contains('delay-3')) return 600
            return 0 // delay-0 or no delay
        }

        // Create a single IntersectionObserver for better performance
        const observer = new IntersectionObserver(
            function (entries) {
                entries.forEach((entry) => {
                    // console.log(
                    //     'Intersection detected:',
                    //     entry.target.tagName,
                    //     entry.isIntersecting
                    // )
                    if (entry.isIntersecting === true) {
                        // Clear any existing timeout for this element
                        if (animatingElements.has(entry.target)) {
                            clearTimeout(animatingElements.get(entry.target))
                        }

                        const delayTime = getDelayTime(entry.target)

                        // Add animated class with delay to respect stagger timing
                        const timeoutId = setTimeout(() => {
                            // console.log(
                            //     'Adding animated class to:',
                            //     entry.target.tagName,
                            //     entry.target.className,
                            //     'with delay:', delayTime
                            // )
                            entry.target.classList.add('animated')
                            animatingElements.delete(entry.target)
                        }, delayTime)

                        animatingElements.set(entry.target, timeoutId)
                    } else {
                        // Remove animated class with reverse delay to maintain stagger effect
                        const delayTime = getDelayTime(entry.target)

                        // Clear any pending timeout for this element
                        if (animatingElements.has(entry.target)) {
                            clearTimeout(animatingElements.get(entry.target))
                            animatingElements.delete(entry.target)
                        }

                        // Add reverse delay for animating out
                        const reverseTimeoutId = setTimeout(() => {
                            // console.log(
                            //     'Removing animated class from:',
                            //     entry.target.tagName,
                            //     entry.target.className,
                            //     'with reverse delay:', delayTime
                            // )
                            entry.target.classList.remove('animated')
                        }, delayTime)

                        animatingElements.set(entry.target, reverseTimeoutId)
                    }
                })
            },
            {
                threshold: [0.15], // Trigger at 15% visibility (single threshold for more predictable timing)
                rootMargin: '0px 0px -100px 0px', // Start animation 100px before element is fully visible
            }
        )

        // Observe all elements
        elementsToObserve.forEach(function (el) {
            observer.observe(el)
        })

        // Debug logging
        // console.log(
        //     `View animations initialized for ${elementsToObserve.length} elements`
        // )
    }
})()
